var lang;
var shopName;

function baseShopVars() {
  if (location.hostname.match('wilsondo.sk')) {
    shopName = "wsk";
    lang = "sk";
  } else if (location.hostname.match('wilsondo.hu')) {
    shopName = "whu";
    lang = "hu";
  } else if (location.hostname.match('wilsondo.cz')) {
    shopName = "wcz";
    lang = "cs";
  } else if (location.hostname.match('wilsondo.ro')) {
    shopName = "wro";
    lang = "ro";
  } else if (location.hostname.match('wilsondo.bg')) {
    shopName = "wbg";
    lang = "bg";
  } else if (location.hostname.match('wilsondo.hr')) {
    shopName = "whr";
    lang = "hr";
  } else if (location.hostname.match('wilsondo.si')) {
    shopName = "wsi";
    lang = "si";
  } else if (location.hostname.match('wilsondo.ua')) {
    shopName = "wua";
    lang = "ua";
  } else if (location.hostname.match('627791.myshoptet.com')) {
    shopName = "test";
    lang = "cs";
  } else if (location.hostname.match('detskapostel.com')) {
    shopName = "dpc";
    lang = "sk";
  } else if (location.hostname.match('matrac-es-en.hu')) {
    shopName = "mee";
    lang = "hu";
  } else if (location.hostname.match('ja-a-matrac.sk')) {
    shopName = "jam";
    lang = "sk";
  } else if (location.hostname.match('emeletes-agyak.hu')) {
    shopName = "eag";
    lang = "hu";
  } else if (location.hostname.match('poschodovky.sk')) {
    shopName = "pos";
    lang = "sk";
  }

  switch(shopName) {
    case 'wsk':
      // code block
      break;
    case 'whu':
      // code block
      break;
    case 'wcz':
      // code block
      break;
    case 'wro':
      // code block
      break;
    case 'wbg':
      // code block
      break;
    case 'whr':
      // code block
      break;
    case 'wsi':
      // code block
      break;
    case 'wua':
      // code block
      break;
  }

  switch(lang) {
    case 'sk':
      // code block
      break;
    case 'hu':
      // code block
      break;
    case 'cs':
      // code block
      break;
    case 'ro':
      // code block
      break;
    case 'bg':
      // code block
      break;
    case 'hr':
      // code block
      break;
    case 'si':
      // code block
      break;
    case 'ua':
      // code block
      break;
  }
}